import styled from 'styled-components';
import {
  white, black, darkGrey, blue, lighterBlue, red, openSans, tekoMedium, openSansBold, teko,
} from '../../../utils/theme';
import { colorWithHover } from '../../../utils/animations';
import { tablet, mobile } from '../../../utils/breakpoints';

export const Container = styled.div`
  padding: 50px 0px;
  position: relative;
  max-width: 100vw;
  overflow-x: hidden;

  @media (max-width: ${tablet.max}px) {
    background: ${white};
    height: auto;
    padding: 0;

    .featured-img {
      width: 100%;
    }
  }
  
  .link-external {
    font-size: 33px;
    letter-spacing: 2.76px;
    text-decoration: none;
    display: inline-block;
    text-transform: uppercase;
    text-align: center;
    cursor: pointer;
    height: 40px;
    padding: 0 12px 0 9px;
    line-height: 40px;
    margin-top: 30px;
    align-self: flex-end;
    ${teko};
    
    ${colorWithHover({
    color: lighterBlue,
    inverse: white,
    borderWidth: '2px',
  })}
    
    
    white-space: nowrap;
  
    ::before {
      content: '';
      height: 3px;
    }
  
    span {
      cursor: pointer;
      margin-right: -6px;
    }
  
    &.xfl-button--header {
      padding: 10px 15px;
    }
  
    .button-red {
      color: ${red};
    }
  
    @media (max-width: ${mobile.max}px) {
      font-size: 47px;
      padding-top: 8px;
    }
  }
  
  .link-internal {
    font-size: 33px;
    letter-spacing: 2.76px;
    text-decoration: none;
    display: inline-block;
    text-transform: uppercase;
    text-align: center;
    cursor: pointer;
    height: 40px;
    padding: 0 12px 0 9px;
    line-height: 40px;
    margin-top: 30px;
    align-self: flex-end;
    ${teko};
  
  
    ${colorWithHover({
    color: lighterBlue,
    inverse: white,
    borderWidth: '2px',
  })}
    white-space: nowrap;
  
    ::before {
      content: '';
      height: 3px;
    }
  
    span {
      cursor: pointer;
      margin-right: -6px;
    }
  
    &.xfl-button--header {
      padding: 10px 15px;
    }
  
    .button-red {
      color: ${red};
    }
  
    @media (max-width: ${mobile.max}px) {
      font-size: 47px;
      padding-top: 8px;
    }
  }
`;

export const Content = styled.div`
  padding: 60px 50px;
  float: right;
  min-height: 395px;
  width: 421px;
  background-color: ${white};
  text-align: left;
  ${openSans} font-size: 12px;
  color: ${black};
  letter-spacing: 0.4px;
  line-height: 24px;

  p {
    color: ${darkGrey};
    opacity: 0.9;
    ${openSans} font-size: 12px;
    letter-spacing: 1.4px;
    line-height: 22px;
    margin-top: 16px;
  }

  @media (max-width: ${tablet.max}px) {
    margin: 0;
    padding: 27px 0;
    min-height: auto;
    width: 100%;
  }

  @media (max-width: ${tablet.max}px) {
    padding: 27px 30px;
  }
`;

export const Title = styled.h3`
  color: ${blue};
  text-transform: uppercase;
  margin-bottom: 16px;
  ${tekoMedium} font-size: 33px;
  letter-spacing: 3px;
  line-height: 29px;

  @media (max-width: ${tablet.max}px) {
    margin-bottom: 8px;
    font-size: 24px;
  }
`;

export const ParallaxContainer = styled.div`
  width: calc(1.1 * 651px);
`;

export const ArticleImg = styled.div`
  display: none;
  max-width: none;

  @media (max-width: ${tablet.max}px) {
    display: block;
    width: 100%;
  }
`;

export const Author = styled.span`
  ${openSans} font-size: 12px;
  color: ${black};
  letter-spacing: 0.4px;
  line-height: 24px;

  &:after {
    content: ' ';
  }
`;

export const Date = styled.span`
  ${openSansBold} font-size: 12px;
  color: ${black};
  letter-spacing: 0.4px;
  line-height: 24px;

  &:before {
    content: ' ';
  }
`;



// WEBPACK FOOTER //
// ./src/components/featured-article/styles/featured-article.style.js